var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "35px",
    viewBox: "0 0 34 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 83") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 14,
    transform: "translate(-33.000000, -461.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-83",
    transform: "translate(33.000000, 461.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#203049",
    cx: 17,
    cy: 17.8,
    r: 17
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-91",
    transform: "translate(11.000000, 10.000000)",
    stroke: "#5F8AEA",
    strokeLinecap: "round",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84-124",
    points: "1.04114177 4.53093198 5.49341342 -1.13686838e-13 10.2632219 4.53093198"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.65218183,
    y1: -1.13686838e-13,
    x2: 5.65218183,
    y2: 12.3006051,
    id: "\\u8DEF\\u5F84-125"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 14.320512,
    x2: 11.592406,
    y2: 14.320512,
    id: "\\u8DEF\\u5F84-126"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.31aaa5970b5a29bf52087116e6437fb8.svg";
export { ForwardRef as ReactComponent };